export const userListConfig = {
  url: 'https://kali-dev-dc.vlinder.io/digicert/user/find',
  bulkOptions: [
    {
      value: 'pay',
      label: 'Pay',
    },
  ],
  ultTableHeader: [
    'Application ID',
    'Action',
    'Application Type',
    'Name',
    'Application Started On',
    'Last Modified',
    // "Status",
    'Payment Required',
  ],
  ultUsers: [],
  currentPage: 1,
  pageSize: 10,
  totalCount: 2,
  totalPages: 1,
  activePage: 1,
  role: 'admin',
};
